import { isEmpty } from "lodash";
import {
  formatMissingRequiredAttributesMessage,
  getMissingRequiredAttributeLabels,
} from "src/hooks/useTagFormValidator";

export const validationErrorForCreateSave = ({
  invalidFields,
  selectedTag,
  displayValue,
}) => {
  if (!isEmpty(invalidFields)) {
    return new Error(
      formatMissingRequiredAttributesMessage(
        getMissingRequiredAttributeLabels(invalidFields, selectedTag, true)
      ) ?? "Required attributes are missing"
    );
  }
  if (!displayValue) {
    return new Error("Display value can not be empty");
  }
  return null;
};

export const newTagPayload = (displayValue, updatedAttributes) => ({
  displayValue,
  isUserCreatedTagValue: true,
  ...(!isEmpty(updatedAttributes) && { attributes: updatedAttributes }),
});
